import "../../../styles/Auth/report.css";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell
} from "recharts";
import { getData } from "../../../webService/webservice.js";
import React, { useEffect, useState, useRef } from "react";
import { Users } from "lucide-react";
const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <div className="sales-tooltip">
                <p>{payload[0].payload.name}</p>
                <p>₹{payload[0].value.toLocaleString()}</p>
            </div>
        );
    }
    return null;
};
const SalesReport = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState("");
    const sessionToken = sessionStorage.getItem("sessionToken");
    const colors = ["#8D2629", "#dfbd57", "#e6cf89", "#EFE0AC"];

    const fetchSalesReport = async (start = startDate, end = endDate) => {
        try {
            setLoading(true);

            const query = [];
            if (start) query.push(`startDate=${start}`);
            if (end) query.push(`endDate=${end}`);
            const queryString = query.length ? `?${query.join("&")}` : "";

            const response = await getData(
                `reports/reports/sales${queryString}`,
                {},
                sessionToken
            );

            if (response.success) {
                const results = response.data.products || [];

                // Convert backend → frontend
                const formatted = results.map(item => ({
                    name: item.name,
                    qty: item.qty,
                    value: item.totalValue
                }));

                setData(formatted);
            }
        } catch (error) {
            console.error("Error fetching sales report:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleApplyDate = () => {
        fetchSalesReport(startDate, endDate);
    };

    const handleClear = () => {
        setStartDate("");
        setEndDate("");
        setData([]);
        setUsers("");
    };
    const fetchUsers = async () => {
        try {
            const res = await getData("/users/users", {}, sessionToken);

            const results =
                res?.data?.[0]?.paginatedResults && Array.isArray(res.data[0].paginatedResults)
                    ? res.data[0].paginatedResults
                    : [];

            setUsers(results);
        } catch (error) {
            console.error("Failed to load users:", error);
            setUsers([]);
        }
    };


    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <div className="summary-layout1">
            <div className="summary-content1">
                <main className="summary-main1">
                    <h2>Date Range</h2>

                    <div className="date-range">
                        <div className="start-date">
                            <label className="input-label">Start Date</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                                className="date-input"
                            />

                            <label className="input-label">End Date</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                                className="date-input"
                            />

                            <label className="input-label">Select Staff / User</label>
                            <select
                                value={Users}
                                onChange={e => setUsers(e.target.value)}
                                className="date-input"
                            >
                                <option value="">All Users</option>

                                {Array.isArray(users) &&
                                    users.map(user => (
                                        <option key={user._id} value={user._id}>
                                            {user.name}
                                        </option>
                                    ))}
                            </select>


                            <button onClick={handleApplyDate} className="report-filter-apply-btn">
                                Apply
                            </button>
                            <button onClick={handleClear} className="report-filter-clear-btn">
                                Clear
                            </button>
                        </div>
                    </div>

                    <h3>Sales Report</h3>

                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <div className="sales-report-container">
                            <ResponsiveContainer width="100%" height={300}>
                                <BarChart
                                    data={data}
                                    layout="vertical"
                                    margin={{ top: 20, right: 30, left: 50, bottom: 20 }}
                                >
                                    <XAxis type="number" />
                                    <YAxis dataKey="name" type="category" width={120} />
                                    <Tooltip content={<CustomTooltip />} />

                                    <Bar dataKey="value" barSize={30} radius={[5, 5, 5, 5]}>
                                        {data.map((entry, index) => (
                                            <Cell
                                                key={index}
                                                fill={colors[index % colors.length]}
                                            />
                                        ))}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default SalesReport;
